import ClubClientSystemLink from '../dto/ClubClientSystemLink';
import Error from '../../model/Error';
import axios from 'axios';

export default class ClubClientSystemLinkRepository {
    static findByClub(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/client-system-links`)
                .then((response) => resolve(response.data.data.map((link) => ClubClientSystemLink.fromData(link))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static update(clubId, clientSystemLinks) {
        const updatedLinks = clientSystemLinks.filter((link) => link.deleted !== true);
        const deleteLinks = clientSystemLinks.filter((link) => link.deleted === true);

        return new Promise((resolve, reject) => {
            axios
                .put(`/club/clubs/${clubId}/client-system-links`, {
                    clientSystemLinks: updatedLinks.map((link) => link.serialize()),
                    clientSystemLinkDeleteIds: deleteLinks.map((link) => link.id),
                })
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
